import { Component, Input, OnInit, TemplateRef, ChangeDetectorRef } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { ReusableClasses } from 'src/app/middleware/common/reusableclassesAndFunctions/reusable-classes';
import { EncryptionService } from 'src/app/middleware/encryption/encryption.service';
import { FormsService } from '../../services/forms.service';
import * as jwt_decode from 'jwt-decode';
import { ToastrService } from 'ngx-toastr';
import { StatusConstant } from 'src/app/middleware/common/status/status-constant';
import { DataSharingService } from 'src/app/middleware/common/resuableServices/data-sharing.service';
import { SimpleChanges } from '@angular/core';
import { LoaderService } from 'src/app/middleware/shared/loader/loader.service';
import { Observable } from 'rxjs';
import { ConfirmDialogComponent, ConfirmDialogModel } from 'src/app/middleware/common/reusableComponents/confirm-dialog/confirm-dialog.component';
import { FormControl } from '@angular/forms';

@Component({
  selector: 'app-group-detail',
  templateUrl: './group-detail.component.html',
  styleUrls: ['./group-detail.component.scss']
})

export class GroupDetailComponent implements OnInit {
  @Input() participantList: any = [];
  @Input() selectedSentItem: any;
  modulename: string = "Forms";
  databaseId: string;
  organizationId: string;
  currentUser: any;
  indexExpanded: number;
  showUpdateEmail: boolean = false;
  updatedParticpantEmail: string = "";
  numberOfDays: number;
  previousParticipant: any;
  showinput: boolean = false;
  ViewtoFinishButton: boolean = false;
  tokenforLastParticipant: string = "";
  LastGroupList: any = [] = [];
  LastParticipantList: any = [] = [];
  SendButtonDisabled: boolean;
  type: any;
  projectId: any;
  groupRelationParticipantMappingID: any;
  groupID: any;
  relationColour: any;
  relationID: any;
  showAddButton: boolean;
  contactemail: any;
  transRoleList: any[];
  contactsList: any[];
  Roles: any[];
  peoples: any[];
  selectedsharedAccessRole: any[];
  participantEmail: string;
  showContactRoleAddButton: boolean;
  responseHolder: any;
  contactId: any;
  OfficeIDList: any = [];
  myOfficeID: any;
  colourCode: any;
  projectGroups: any = [];
  colorcodeExist: any = [];

  constructor(private loaderService: LoaderService, private dialog: MatDialog, private formsService: FormsService,
    private encryptionAlgo: EncryptionService, private statusConstant: StatusConstant,
    private reusableClass: ReusableClasses, private toastr: ToastrService,
    private _dataSharingService: DataSharingService, private cdr: ChangeDetectorRef) {
    this.numberOfDays = 0;
    this.modulename = 'Forms';
    this.showUpdateEmail = false;
    const encryptedtoken = sessionStorage.getItem('userToken');
    this.databaseId = sessionStorage.getItem('databaseId');
    this.organizationId = sessionStorage.getItem('organizationID');
    const token = this.encryptionAlgo.get(this.reusableClass.encryptionKey, encryptedtoken);
    this.currentUser = jwt_decode(token);
    var offices = JSON.parse(sessionStorage.getItem('officeList'));
    offices.forEach(oe => {
      this.OfficeIDList.push(oe.officeID)
      if (oe.isMyoffice == true)
        this.myOfficeID = oe.officeID;
    });
  }

  ngAfterContentChecked() {
    this.cdr.detectChanges();
  }

  ngOnChanges(changes: SimpleChanges) {
    //For ViewtoFinishButton //
    this.ViewtoFinishButton = false;
    this.LastGroupList = [];
    this.LastParticipantList = [];
    this.tokenforLastParticipant = "";

    this.showUpdateEmail = false;
    this.selectedSentItem;
    this.updatedParticpantEmail = "";
    if (this.participantList != undefined && this.participantList != '') {
    }
    if (this.selectedSentItem != undefined && this.selectedSentItem != null) {
      if (this.selectedSentItem.status == 2) {
        if (this.participantList.length > 0) {
          var check = [];
          var participantData = [];
          var forlastRecord = [];
          participantData = this.participantList;
          check = participantData.filter(x => x.groupName != "Send Final Copy" && x.groupName != "View Only");
          forlastRecord = participantData.filter(x => x.groupName != "Send Final Copy" && x.groupName != "View Only");

          if (check.length > 0) {
            for (var i = 0, len = check.length; i < len; ++i) {
              var projGrpRelationParticipantList = [];
              projGrpRelationParticipantList = check[i].getProjectGroupRelationParticipantMappingModelList;
              if (projGrpRelationParticipantList.length > 0) {
                for (var i1 = 0, len1 = projGrpRelationParticipantList.length; i1 < len1; ++i1) {
                  if (projGrpRelationParticipantList[i1].contactID != 0) {
                    if (projGrpRelationParticipantList[i1].hasCompleted == true && projGrpRelationParticipantList[i1].hasCompleted != null && projGrpRelationParticipantList[i1].hasViewed == true && projGrpRelationParticipantList[i1].isEmailSent == true && (projGrpRelationParticipantList[i1].participantEmail != null && projGrpRelationParticipantList[i1].participantEmail != '')) {
                      this.ViewtoFinishButton = true;
                    } else {
                      this.ViewtoFinishButton = false;
                      return;
                    }
                  }
                  if (projGrpRelationParticipantList[i1].contactID == 0) {
                    if (projGrpRelationParticipantList[i1].hasCompleted == true && projGrpRelationParticipantList[i1].hasCompleted != null && projGrpRelationParticipantList[i1].hasViewed == true && projGrpRelationParticipantList[i1].isEmailSent == true && (projGrpRelationParticipantList[i1].contactEmail != null && projGrpRelationParticipantList[i1].contactEmail != '')) {
                      this.ViewtoFinishButton = true;
                    } else {
                      this.ViewtoFinishButton = false;
                      return;
                    }
                  }
                }
              }
              else {
              }
            }
          }

          if (this.ViewtoFinishButton == true) {
            if (forlastRecord.length > 0) {
              this.LastGroupList = forlastRecord[forlastRecord.length - 1]; //forlastRecord[0].getProjectGroupRelationParticipantMappingModelList;
              //  this.LastParticipantList = this.LastParticipantList[this.LastParticipantList.length-1];            
              if (this.LastGroupList != null && this.LastGroupList != undefined) {
                this.LastParticipantList = Object.values(this.LastGroupList)[2];
                if (this.LastParticipantList.length > 0) {
                  this.LastParticipantList = this.LastParticipantList[this.LastParticipantList.length - 1];
                  if (this.LastParticipantList != null && this.LastParticipantList != undefined) {
                    this.tokenforLastParticipant = Object.values(this.LastParticipantList)[22] + "&status=2";
                  }
                }
              }
            }

            //  if(forlastRecord.length==1){
            //   this.LastParticipantList=forlastRecord[0].getProjectGroupRelationParticipantMappingModelList;
            //   this.LastParticipantList = this.LastParticipantList[this.LastParticipantList.length-1];            
            //   if(this.LastParticipantList!=null && this.LastParticipantList!=undefined){              
            //    this.tokenforLastParticipant = Object.values(this.LastParticipantList)[22]+"&status=2";                             
            //   }
            //  }else{
            //   this.LastGroupList = forlastRecord[forlastRecord.length - 1];
            //    if(this.LastGroupList.length>0){
            //    // LastParticipantList=LastGroupList[0].getProjectGroupRelationParticipantMappingModelList;
            //   }
            //  }
          }
        }
      }
    }

  }

  ngOnInit(): void {
    if (this.participantList != undefined && this.participantList != '') {
    }
  }

  togglePanels(index: number) {
    this.indexExpanded = index;
  }

  getShortName(fullName) {
    if(fullName!=null){
      return fullName.split(' ').map(n => n[0]).join('');
    }   
  }

  editEmail(p, val) {
    p.enableEmailEdit = val;
  }


  getSignedCount(group: any): number {
  return group.getProjectGroupRelationParticipantMappingModelList
    .filter((p: any) => p.hasCompleted === true && !p.isApprover)
    .length;
}

getStatusLabel(p: any): string {
  if (p.hasCompleted && p.isApprover) return 'Approved';
  if (p.hasCompleted && !p.rejectionMessage) return 'Signed';
  if (p.rejectionMessage) return 'Declined';
  if (p.hasViewed && !p.hasCompleted) return 'Viewed';
  if (p.isEmailSent && !p.hasViewed) return 'Sent';
  return 'Not Sent';
}

getStatusClass(p: any): string {
  if (p.hasCompleted && p.isApprover) return 'approved';
  if (p.hasCompleted && !p.rejectionMessage) return 'signed';
  if (p.rejectionMessage) return 'declined';
  if (p.hasViewed) return 'viewed';
  if (p.isEmailSent) return 'sent';
  return 'not-sent';
}


  updateEmail(p) {
    this.participantList.map(function (entry) {
      entry.getProjectGroupRelationParticipantMappingModelList.map(function (fieldentry) {
        fieldentry["showUpdateEmail"] = false;
        return entry;
      });
    });
    if (p.hasCompleted == true) {
      return;
    } else {
      this.showUpdateEmail = !this.showUpdateEmail;
      p["showUpdateEmail"] = this.showUpdateEmail;
    }
  }

  EditParticipantEmail(participantDetails: any, event: any) {
    if (event.target.value == "") {
      this.showUpdateEmail = !this.showUpdateEmail;
      participantDetails["showUpdateEmail"] = this.showUpdateEmail;
      this.toastr.success('Please provide email');
      return;
    }
    if (participantDetails.contactEmail == event.target.value.trim() || participantDetails.participantEmail == event.target.value.trim()) {
      this.showUpdateEmail = !this.showUpdateEmail;
      this.toastr.success('Please provide different email to update.');
      return;
    } else if (event.target.value != "") {
      this.loaderService.show();
      let reqModel = {
        GroupRelationParticipantMappingID: participantDetails.groupRelationParticipantMappingID,
        ProjectID: this.selectedSentItem.projectID,
        userID: this.currentUser.UID,
        organizationID: this.organizationId,
        databaseID: this.databaseId,
        contactId: participantDetails.contactID,
        ModifiedParticipantEmail: event.target.value.trim(),
        PreviousParticipantEmail: participantDetails.contactEmail == '' ? participantDetails.participantEmail : participantDetails.contactEmail
      }
      this.formsService.EditParticipantEmail(reqModel).subscribe(respnse => {
        this.loaderService.hide();
        if (respnse) {
          this.showUpdateEmail = !this.showUpdateEmail;
          if (participantDetails.contactEmail != '')
            participantDetails.contactEmail = event.target.value.trim();
          if (participantDetails.participantEmail != '')
            participantDetails.participantEmail = event.target.value.trim();
          this.updatedParticpantEmail = "";
          participantDetails["showUpdateEmail"] = this.showUpdateEmail;
          this.toastr.success('Email updated successfully');
          this.getParticipantDetails();
        }
      });
    }
  }

  getParticipantDetails() {
    var ReqModel = {
      projectID: this.selectedSentItem.projectID,
      projectInboxSentID: 0,
      emailFieldID: 0,
      nameFieldID: 0,
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      databaseID: Number(this.databaseId),
    }
    this.formsService.GetSentBoxItemParticipantList(ReqModel).subscribe(response => {
      if (response.data != null) {
        this.formsService.setIsprojectExtended(false);
        this.participantList = response.data;
        this.participantList.forEach(e => {
          e.getProjectGroupRelationParticipantMappingModelList.forEach(n => {
            n.enableEmailEdit = false;
            n.signingToken = window.location.href.split(window.location.pathname)[0] + "/request/signature?token=" + n.signingToken
          });
          //e.signHref=window.location.href.split(window.location.pathname)[0]+"/request/signature?token="+e.signingToken
        });
      }
      else {
      }
    });
  }

  remindParticipant(participantDetails: any) {
    let reqModel = {
      groupParticipantRelationId: participantDetails.groupRelationParticipantMappingID,
      participantEmail: participantDetails.participantEmail,
      userID: this.currentUser.UID,
      organizationID: this.organizationId,
      databaseID: this.databaseId,
      contactId: participantDetails.contactID
    }
    this.formsService.remindParticipant(reqModel).subscribe(response => {
      if (response.status == this.statusConstant.statusSuccess) {
        this.toastr.success('The reminder has been sent.');
      } else {
        this.toastr.warning('The project group is not active yet.');
      }
    });
  }

  ReopenSignatureLink(participantDetails: any) {
    if (this.selectedSentItem.status == 3) {
      this.toastr.warning('Project is already completed, Please reset whole project to sign again.');
      return;
    }
    this.loaderService.show();
    let reqModel = {
      GroupRelationParticipantMappingID: participantDetails.groupRelationParticipantMappingID,
      participantEmail: participantDetails.participantEmail,
      ProjectID: this.selectedSentItem.projectID,
      userID: this.currentUser.UID,
      organizationID: this.organizationId,
      databaseID: this.databaseId,
      contactId: participantDetails.contactID
    }
    this.formsService.ReopenSignatureLink(reqModel).subscribe(response => {
      this.loaderService.hide();
      if (response) {
        this.toastr.success('Signing link opened successfully');
      } else {
        this.toastr.error('Request failed');
      }
    });
  }
  ResendEmail(participantDetails: any, isUpdateDetails: boolean = false) {
    this.loaderService.show();
    let reqModel = {
      GroupRelationParticipantMappingID: participantDetails.groupRelationParticipantMappingID,
      participantEmail: participantDetails.participantEmail,
      ProjectID: this.selectedSentItem.projectID,
      userID: this.currentUser.UID,
      organizationID: this.organizationId,
      databaseID: this.databaseId,
      contactId: participantDetails.contactID,
      isUpdateDetails: isUpdateDetails
    }
    this.formsService.ResendEmail(reqModel).subscribe(response => {
      this.loaderService.hide();
      if (response) {
        this.toastr.success('The reminder has been sent.');
        if (isUpdateDetails == true) {
          this.getParticipantDetails();
        }
      } else {
        this.toastr.warning('The project group is not active yet.');
      }
    });
  }

  remindParticipantAnonymousEmail(participantDetails: any) {
    let reqModel = {
      groupParticipantRelationId: participantDetails.groupRelationParticipantMappingID,
      participantEmail: participantDetails.contactEmail,
      userID: this.currentUser.UID,
      organizationID: this.organizationId,
      databaseID: this.databaseId,
      contactId: participantDetails.contactID
    }
    this.formsService.remindParticipant(reqModel).subscribe(response => {
      if (response.status == this.statusConstant.statusSuccess) {
        this.toastr.success('The reminder has been sent.');
      } else {
        this.toastr.warning('The project group is not active yet.');
      }
    });
  }

  renewProject() {
    let participants = [];
    this.participantList.forEach(p => {
      participants.push({ participantID: p.groupRelationParticipantMappingID, groupID: p.groupID })
    });

    let reqModel = {
      projectID: this.selectedSentItem.projectID,
      participants: participants,
      extendDays: this.numberOfDays,
      userID: this.currentUser.UID,
      organizationID: this.organizationId,
      databaseID: this.databaseId
    }
    this.formsService.renewProject(reqModel).subscribe(response => {
      if (response.status == this.statusConstant.statusSuccess) {
        this.formsService.setIsprojectExtended(true);
        this.selectedSentItem.projectExpiry = false;
        this.dialog.closeAll();
      }
      else {
        this.dialog.closeAll();
      }
    });
  }


  onChange(value) {
    this.numberOfDays = value;
  }

  EntendProject(templateRef: TemplateRef<any>) {
    const dialogRef = this.dialog.open(templateRef, {
    });
  }


  ViewtoFinish() {
    if (this.tokenforLastParticipant != null && this.tokenforLastParticipant != undefined && this.tokenforLastParticipant != "") {
      window.open(this.tokenforLastParticipant, "_blank");
    }
  }

  close() {
    this.dialog.closeAll();
  }

  RemoveRelation(group) {
    const message = `Are you sure you want to delete this participant?`;
    const title = `Confirm Delete`;
    const confirm = `Delete`;
    const dialogData = new ConfirmDialogModel(title, message,confirm);
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      panelClass: 'edituserdetails',
      maxWidth: '1000px',
      maxHeight: '500px',
      data: dialogData,
    });
    dialogRef.beforeClosed().subscribe(async (dialogResult) => {
      try {
        if (dialogResult) {
          //this.loaderService.show();
          if (group !== undefined) {
            this.projectGroups.forEach(e => {
              if (e.projGrpRelationParticipantList.length > 0) {
                e.projGrpRelationParticipantList.forEach(ee => {
                  if (ee.groupRelationParticipantMappingID == group.groupRelationParticipantMappingID) {
                    ee.contactEmail = "";
                    ee.participantName = "";
                  }
                });
              }
            });
          }

          if (this.projectGroups.length > 0) {
            var check = []
            check = this.projectGroups.filter(x => x.groupType === 1);
            if (check.length > 0) {
              for (var i = 0, len = check.length; i < len; ++i) {
                var projGrpRelationParticipantList = [];
                projGrpRelationParticipantList = check[i].projGrpRelationParticipantList;
                if (projGrpRelationParticipantList.length > 0) {
                  for (var i1 = 0, len1 = projGrpRelationParticipantList.length; i1 < len1; ++i1) {
                    if (projGrpRelationParticipantList[i1].contactEmail != "" || projGrpRelationParticipantList[i1].participantEmail != "") {
                      this.SendButtonDisabled = true;
                      return;
                    } else {
                      this.SendButtonDisabled = false;
                      // return;
                    }
                  }
                }
                else {
                }
              }
            }
          }
        }
      } catch (e) {
        Observable.throw(e);
      }
    });
  }

  dialogRef: any;
  assignUser(templateRef: TemplateRef<any>, isShare: boolean, isRole: boolean, contact: any, p, p1) {
    this.type = p1.type;
    this.projectId = p1.projectID;
    this.groupRelationParticipantMappingID = p.groupRelationParticipantMappingID;
    this.groupID = p.groupID;
    this.relationColour = p.relationColour;
    this.relationID = p.relationID;
    this.showAddButton = false;
    this.contactemail = p.contactEmail;
    this.transRoleList = [];
    this.contactsList = [];
    this.Roles = [];
    this.peoples = [];
    this.selectedsharedAccessRole = [];
    this.participantEmail = "";
    this.showContactRoleAddButton = false;
    this.dialogRef = this.dialog.open(templateRef, {
      panelClass: 'custom-modalbox'
    });
  }
  timeout = null;
  searchUserProject(val) {
    this.contactsList = [];
    if (val != '') {
      clearTimeout(this.timeout)
      this.timeout = setTimeout(() => {
        this.getContactListCoreImplementation(val)
      }, 500);
    } else {
      this.contactsList = [];
    }
  }
  GetGroupList(projectID: any, templateRef: TemplateRef<any>) {
    this.colourCode;
    var ReqModel = {
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      databaseID: Number(this.databaseId),
      projectID: projectID,
      type: Number(1),// 1 for Project and 2 for Template
      OfficeID: this.myOfficeID
    }
    this.loaderService.show();
    this.formsService.GetGroupList(ReqModel).subscribe(response => {
      if (response != undefined) {
        this.responseHolder = response;
        if (this.responseHolder.status == this.statusConstant.statusSuccess) {
          this.loaderService.hide();
          this.dialog.open(templateRef, {
            panelClass: 'signatureModal',
          });
          this.projectGroups = this.responseHolder.data.groupList;//.filter(m=>m.groupType==1);
          //this.stepCompleted =this.responseHolder.data.projectDetail.stepCompleted;
          // this.SendFinalCopy=this.responseHolder.data.find(m=>m.groupType==2);
          // this.viewOnlylist=this.responseHolder.data.find(m=>m.groupType==3);           
          //sessionStorage.setItem('ProjectName',this.responseHolder.data.projectDetail.projectName);
          // this._dataSharingService.sendSelectedProjectName(sessionStorage.getItem('ProjectName'));
          //this._dataSharingService.sendSelectedModuleName('Form');
          //this._dataSharingService.sendProjectNameAlreadyExist(false); 
          this.colorcodeExist = [];
          var data = [];
          data = this.projectGroups;
          if (data.length > 0) {
            for (var i = 0, len = data.length; i < len; ++i) {
              var projGrpRelationParticipantList = [];
              projGrpRelationParticipantList = data[i].projGrpRelationParticipantList;
              for (var i1 = 0, len1 = projGrpRelationParticipantList.length; i1 < len1; ++i1) {
                var req = {
                  colourCode: projGrpRelationParticipantList[i1].colourCode,
                  transctionalRoleID: projGrpRelationParticipantList[i1].relationID
                }
                this.colorcodeExist.push(req);
              }
            }
          }
          this.colorcodeExist;
          // if (this.colorcodeExist.length > 0) {
          //   // let _notExistColor = this.filterColorCodeList(this.colorcodeExist);
          //   // this.colourCode = _notExistColor.map(s => Object.assign(s)); 

          //   var colorcodes = this.ShowcolourCode;
          //   let _notExistColor = colorcodes.filter(({ colourCode: id1 }) => !this.colorcodeExist.some(({ colourCode: id2 }) => id2 === id1));
          //   this.colourCode = _notExistColor.map(s => Object.assign(s));            
          // }
          // else {
          //   this.colourCode = this.ShowcolourCode;
          // }

          var check = []
          // check = this.responseHolder.data.filter(x => x.groupType === 1);
          //   if(check.length > 0){
          //     var checkParticipant =check[0].projGrpRelationParticipantList;
          //     if(checkParticipant.length > 0) {
          //       this.SubmitNextButtonDisabled=true;
          //     } else {
          //       this.SubmitNextButtonDisabled=false;
          //     }
          //   }
          // check = this.responseHolder.data.groupList.filter(x => x.groupType === 1);
          // if(check.length > 0){
          //   for (var i = 0, len = check.length; i < len; ++i) {
          //     var projGrpRelationParticipantList = [];
          //     projGrpRelationParticipantList = check[i].projGrpRelationParticipantList;
          //     if(projGrpRelationParticipantList.length > 0){             
          //       // if(projGrpRelationParticipantList.filter(x=>x.participantEmail==null).length>0)
          //       // this.SubmitNextButtonDisabled=false;
          //       // else
          //       ////this.SubmitNextButtonDisabled=true;
          //       return;              
          //     }
          //     else{                
          //       this.SubmitNextButtonDisabled=false;
          //     }              
          //   }            
          // }

          // if(check.length == 0){
          //   this.SubmitNextButtonDisabled=false;
          // }

          // if(this.SubmitNextButtonDisabled==false){
          //   check = this.responseHolder.data.groupList.filter(x => x.groupType === 2);
          //   if(check.length > 0){
          //     var checkParticipant =check[0].projGrpRelationParticipantList;
          //     if(checkParticipant.length > 0){
          //       // if(projGrpRelationParticipantList.filter(x=>x.participantEmail==null).length>0)
          //       // this.SubmitNextButtonDisabled=false;
          //       // else
          //       this.SubmitNextButtonDisabled=true;
          //     } else {
          //       this.SubmitNextButtonDisabled=false;
          //     }
          //   }
          // }

          // if(this.SubmitNextButtonDisabled==false){
          //   check = this.responseHolder.data.groupList.filter(x => x.groupType === 3);
          //   if(check.length > 0){
          //     var checkParticipant =check[0].projGrpRelationParticipantList;
          //     if(checkParticipant.length > 0){
          //       // if(projGrpRelationParticipantList.filter(x=>x.participantEmail==null).length>0)
          //       // this.SubmitNextButtonDisabled=false;
          //       // else
          //       this.SubmitNextButtonDisabled=true;
          //     }else {
          //       this.SubmitNextButtonDisabled=false;
          //     }
          //   }
          // }       

          // this.cdr.detectChanges();
        } else {
          this.loaderService.hide();
        }
      } else {
        this.loaderService.hide();
      }
    });
  }
  getContactListCoreImplementation(searchValue: any) {
    var ReqModel = {
      DatabaseID: Number(this.databaseId),
      OrganizationID: Number(this.organizationId),
      UserID: this.currentUser.UID,
      searchValue: searchValue,
      PageSize: 0,
    }
    this.formsService.GetContactListCoreImplementation(ReqModel).subscribe(response => {
      if (response != undefined) {
        this.responseHolder = response;
        if (this.responseHolder.status == this.statusConstant.statusSuccess) {
          this.peoples = [];
          this.contactsList = response.data.contactListModel;
          this.contactsList.forEach(e => {
            e.shortName = e.name.match(/\b(\w)/g).join('');
          });

          const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          var check = re.test(String(searchValue).toLowerCase());

          if (check == true) {
            var ReqModels = {
              contactID: 0,
              email: searchValue,
              img: "",
              name: "",
              shortName: ""
            }
            this.contactemail = searchValue;
            this.showAddButton = true;
            this.SendButtonDisabled = true;
          }
          if (check == false) {
            this.showAddButton = false;
            this.SendButtonDisabled = false;
          }
        } else {
          this.contactsList = [];
        }
      }
    }

    )
  }

  addUpdateParticipants() {

    var name = "";
    if (this.peoples.length > 0) {
      if (this.peoples[0].email != "" || this.peoples[0].email != null || this.peoples[0].email != undefined) {
        this.contactemail = this.peoples[0].email;
        name = this.peoples[0].name;
        this.contactId = this.peoples[0].contactID;
      }
    }
    if (this.peoples.length == 0) {
      this.contactId = 0;
    }
    if (this.contactemail != "" || this.contactemail != null || this.contactemail != undefined) {
      const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      var check = re.test(String(this.contactemail).toLowerCase());
      if (check == true) {
      } else {
        this.toastr.warning('Please provide valid email.', '', {
          timeOut: 3000,
        });
        return;
      }
    }

    this.closeAssignParticipant();
    this.loaderService.show();
    //this.projectGroups
    this.projectGroups.forEach(e => {
      if (e.projGrpRelationParticipantList.length > 0) {
        e.projGrpRelationParticipantList.forEach(ee => {
          if (ee.groupRelationParticipantMappingID == this.groupRelationParticipantMappingID) {
            ee.contactEmail = this.contactemail;
            ee.participantName = name;
          }
        });
      }
    });
    this.SendButtonDisabled = true;
    var ReqModel = {
      groupRelationParticipantMappingID: this.groupRelationParticipantMappingID,
      contactEmail: this.contactemail,
      contactID: this.contactId,
      officeID: this.myOfficeID,
      userID: this.currentUser.UID,
      databaseID: Number(this.databaseId),
      organizationID: Number(this.organizationId),
    }
    // return;
    this.formsService.UpdateParticipantDeatil(ReqModel).subscribe(response => {
      if (response != undefined) {
        this.responseHolder = response;
        if (this.responseHolder.status == this.statusConstant.statusSuccess) {
          this.peoples = [];
          this.showAddButton = false;
          this.loaderService.hide();
          this.ResendEmail({
            groupRelationParticipantMappingID: this.groupRelationParticipantMappingID,
            participantEmail: this.contactemail,
            contactID: this.contactId
          }, true);
        } else {
          this.peoples = [];
          this.showAddButton = false;
          this.loaderService.hide();
        }
      } else {
        this.peoples = [];
        this.showAddButton = false;
        // this.SendButtonDisabled=false;
        this.loaderService.hide();
      }
    });
  }

  closeAssignParticipant() {
    if (this.dialogRef != undefined) {
      this.dialogRef.close();
      this.peoples = [];
      this.SendButtonDisabled = false;
      this.showAddButton = false;
    }
  }
  stateCtrl = new FormControl();
  contactSelected(contactSelected: any) {
    this.peoples = [];
    let user = this.peoples.find(m => m.contactID == contactSelected.contactID);
    if (user == undefined || user == '' || user == null) {
      if (contactSelected.contactID == 0) {
        return;
      }
      if (contactSelected.email == "" || contactSelected.email == null || contactSelected.email == undefined) {
        this.toastr.warning('Selected contact is not associated with email.', '', {
          timeOut: 3000,
        });
        return;
      }
      var ReqModel = {
        contactID: contactSelected.contactID,
        email: contactSelected.email,
        name: contactSelected.name,
        img: contactSelected.imageUrl,
        shortName: contactSelected.shortName,
      }
      this.peoples.unshift(ReqModel);
      this.stateCtrl.reset();
      if (this.peoples.length > 0) {
        this.showAddButton = true;
      } else {
        this.showAddButton = false;
      }
    }
  }
}
